import Bottombar from "@/components/bottombar"
import Button from "@/components/button"
import Topbar from "@/components/topbar"
import { Icon } from "@/icons/icon"
import useStore from "@/store"
import { useNavigate } from "react-router"
import { format } from "date-fns"
import { useDisableBack } from "@/lib/utils"

export default function ShiftEndedPage() {
  const navigate = useNavigate()
  const { employee } = useStore((state) => state.user)
  const store = useStore()

  useDisableBack()

  async function handleClickStart() {
    await navigate("/manage-processes")
  }

  function formatTime() {
    return format(new Date(), "d MMMM yyyy, h:mm a")
  }

  return (
    <div className="relative h-dvh">
      <Topbar className="sticky" title="Unit Quality" subtitle={employee.name}>
      </Topbar>

      <div className="p-4 pt-8 mt-15">
        <Icon name="SuccessBig" className="h-18 w-auto mx-auto" />

        <div className="flex flex-col items-center mt-6">
          <h1 className="text-2xl font-poppins font-semibold leading-8">
            End of Process
          </h1>

          <div className="text-label-text text-center mt-2">
            <p className="font-semibold">{store.user.plant.city}</p>
            <p>{store.user.plant.name}</p>
          </div>

          <div className="font-medium text-button mt-7.5 text-xs">
            {formatTime()}
          </div>
        </div>
      </div>

      <Bottombar className="absolute bottom-0  flex gap-4">
        <Button
          className="grow flex items-center justify-center gap-2.5"
          onClick={handleClickStart}
        >
          <span>Start A New Process</span>
          <Icon name="FilePlus" className="h-6 w-auto" />
        </Button>
      </Bottombar>
    </div>
  )
}
